'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISPLAY_MODE_LIST = exports.DISPLAY_MODE_MAP = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTranslate = require('@gandi/react-translate');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

var _replaceLang = require('../../shared/replaceLang');

var _replaceLang2 = _interopRequireDefault(_replaceLang);

var _ButtonTooltip = require('../ButtonTooltip/ButtonTooltip');

var _ButtonTooltip2 = _interopRequireDefault(_ButtonTooltip);

require('./FilterBlock.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DISPLAY_MODE_MAP = exports.DISPLAY_MODE_MAP = 0;
var DISPLAY_MODE_LIST = exports.DISPLAY_MODE_LIST = 1;

var FilterBlock = function (_Component) {
  (0, _inherits3.default)(FilterBlock, _Component);

  function FilterBlock(props) {
    (0, _classCallCheck3.default)(this, FilterBlock);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FilterBlock.__proto__ || (0, _getPrototypeOf2.default)(FilterBlock)).call(this, props));

    _this.state = {
      categoryChecked: null
    };
    return _this;
  }

  (0, _createClass3.default)(FilterBlock, [{
    key: 'onClick',
    value: function onClick(display, event) {
      event.preventDefault();
      this.props.triggerCallback(display);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var __ = this.props.__;
      var universes = this.props.filters.items;

      return _react2.default.createElement(
        'div',
        { className: 'FilterBlock', style: this.props.styleContainer },
        _react2.default.createElement(
          'div',
          { className: 'FilterBlock__top' },
          universes && universes.length > 0 && _react2.default.createElement(
            'h2',
            null,
            _react2.default.createElement(
              _ButtonTooltip2.default,
              {
                className: (0, _classname2.default)("FilterBlock__button", { 'is-open': this.props.isOpen }),
                onClick: this.toggleFilters.bind(this),
                'aria-controls': 'FiltersBlock__filters',
                'aria-expanded': this.props.isOpen,
                'aria-label': __('FilterBlock|RefineAria')
              },
              __('FilterBlock|Refine'),
              _react2.default.createElement('span', { className: 'FilterBlock__arrow icon icon-arrow-down' })
            )
          ),
          this.props.displayResults && _react2.default.createElement(
            'span',
            {
              className: 'FilterBlock__number',
              'aria-live': 'polite'
            },
            __('FilterBlock|%(count)s Results', { count: this.props.nbResults })
          ),
          _react2.default.createElement(
            'div',
            { className: 'FilterBlock__icons' },
            this.props.displayResults && _react2.default.createElement(
              'span',
              { className: (0, _classname2.default)("FilterBlock__icon", { 'FilterBlock__icon--gray': this.props.displayMode === DISPLAY_MODE_MAP }) },
              _react2.default.createElement('a', { href: '#', onClick: this.onClick.bind(this, DISPLAY_MODE_LIST), className: 'icon icon-burger-liste' })
            ),
            _react2.default.createElement(
              'span',
              { className: (0, _classname2.default)("FilterBlock__icon", { 'FilterBlock__icon--gray': this.props.displayMode === DISPLAY_MODE_LIST }) },
              _react2.default.createElement('a', { href: '#', onClick: this.onClick.bind(this, DISPLAY_MODE_MAP), className: 'icon icon-map' })
            )
          )
        ),
        universes && universes.length > 0 && _react2.default.createElement(
          'div',
          { id: 'FiltersBlock__filters',
            className: (0, _classname2.default)("FilterBlock__filters-wrapper", { 'is-open': this.props.isOpen }), style: this.props.styleFilters,
            'aria-expanded': this.props.isOpen
          },
          _react2.default.createElement(
            'ul',
            { className: 'FilterBlock__filters' },
            universes.sort(function (a, b) {
              return a.order - b.order;
            }).map(function (item, index) {
              return _react2.default.createElement(
                'li',
                { className: 'FilterBlock__filter', key: index },
                item.unfold === "1" && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'label',
                    {
                      className: (0, _classname2.default)("FilterBlock__filter-link semi-checked")
                    },
                    _react2.default.createElement('input', { type: 'checkbox',
                      checked: _this2.props.categoryOpen === index,
                      onChange: _this2.toggleFilter.bind(_this2, index)
                    }),
                    _react2.default.createElement('span', { className: 'FilterBlock__filter-dummy' }),
                    _react2.default.createElement(
                      'span',
                      { className: 'FilterBlock__filter-label' },
                      (0, _replaceLang2.default)(item.localeLabels, item.defaultLabel, _this2.props.countryCode, _this2.props.lang)
                    )
                  ),
                  item.subUniverses && item.subUniverses.length > 0 && _react2.default.createElement(
                    'ul',
                    { className: (0, _classname2.default)('FilterBlock__filter-children', { 'is-open': _this2.props.categoryOpen === index }) },
                    item.subUniverses.sort(function (a, b) {
                      return a.order - b.order;
                    }).map(function (child, childIndex) {
                      return _react2.default.createElement(
                        'li',
                        {
                          className: (0, _classname2.default)('FilterBlock__filter-child', { 'hidden-xs-up': child.hidden === '1' }),
                          key: childIndex
                        },
                        _react2.default.createElement(
                          'label',
                          {
                            className: (0, _classname2.default)("FilterBlock__filter-link no-text-transform")
                          },
                          _react2.default.createElement('input', { type: 'checkbox',
                            checked: _this2.props.filtersSelected.indexOf(child.id) !== -1,
                            onChange: _this2.selectFilter.bind(_this2, child.id)
                          }),
                          _react2.default.createElement('span', { className: 'FilterBlock__filter-dummy' }),
                          _react2.default.createElement(
                            'span',
                            { className: 'FilterBlock__filter-label' },
                            (0, _replaceLang2.default)(child.localeLabels, child.defaultLabel, _this2.props.countryCode, _this2.props.lang)
                          )
                        ),
                        child.info && child.info.length > 0 && _react2.default.createElement(
                          'div',
                          { className: 'FilterBlock__info' },
                          _react2.default.createElement(
                            'div',
                            { className: 'FilterBlock__info-bubble' },
                            child.info
                          )
                        )
                      );
                    })
                  )
                ),
                item.unfold === "0" && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: '#',
                      className: (0, _classname2.default)("FilterBlock__filter-link", { 'checked': _this2.state.categoryChecked === item.id }),
                      onClick: _this2.selectFilters.bind(_this2, item.subUniverses, item.id)
                    },
                    _react2.default.createElement(
                      'span',
                      null,
                      (0, _replaceLang2.default)(item.localeLabels, item.defaultLabel, _this2.props.countryCode, _this2.props.lang)
                    )
                  )
                )
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'FilterBlock__alert' },
            _react2.default.createElement(
              'a',
              { href: this.props.storeLocatorUrl, target: '_blank', role: 'alert' },
              __('FilterBlock|Are you looking for?')
            )
          )
        )
      );
    }
  }, {
    key: 'selectFilter',
    value: function selectFilter(id) {
      var array = this.props.filtersSelected.slice(0);
      if (array.indexOf(id) !== -1) {
        array.splice(array.indexOf(id), 1);
      } else {
        array.push(id);
      }
      this.props.updateFilters(array);
    }
  }, {
    key: 'selectFilters',
    value: function selectFilters(subUniverses, id, event) {
      event.preventDefault();

      var array = [];

      if (this.state.categoryChecked !== id) {
        // If category is not already checked, check it & close any open category.
        array = subUniverses.map(function (item) {
          return item.id;
        });
        this.setState({
          categoryChecked: id
        });
        this.props.closeFilterCategory();
      } else {
        // If this category is already checked, uncheck all.
        this.setState({
          categoryChecked: null
        });
      }

      this.props.updateFilters(array);
    }
  }, {
    key: 'toggleFilter',
    value: function toggleFilter(index) {
      if (this.props.categoryOpen === index) {
        // Close category.
        this.props.closeFilterCategory();
        this.props.updateFilters([]);
      } else {
        // Open category.
        this.props.openFilterCategory(index);
        this.props.updateFilters(this.props.filters.items[index].subUniverses.map(function (subUniverse) {
          return subUniverse.id;
        }));
        this.setState({
          categoryChecked: null
        });
      }
    }
  }, {
    key: 'toggleFilters',
    value: function toggleFilters(event) {
      event.preventDefault();
      this.props.toggleFilters();
    }
  }]);
  return FilterBlock;
}(_react.Component);

FilterBlock.propTypes = {
  __: _propTypes2.default.func.isRequired, // @see https://github.com/Gandi/react-translate
  categoryOpen: _propTypes2.default.number,
  closeFilterCategory: _propTypes2.default.func,
  countryCode: _propTypes2.default.string,
  displayMode: _propTypes2.default.number,
  displayResults: _propTypes2.default.bool,
  filters: _propTypes2.default.object,
  filtersSelected: _propTypes2.default.array,
  isOpen: _propTypes2.default.bool,
  lang: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  openFilterCategory: _propTypes2.default.func,
  nbResults: _propTypes2.default.number,
  storeLocatorUrl: _propTypes2.default.string,
  styleContainer: _propTypes2.default.object,
  styleFilters: _propTypes2.default.object,
  toggleFilters: _propTypes2.default.func,
  triggerCallback: _propTypes2.default.func,
  updateFilters: _propTypes2.default.func
};

FilterBlock.defaultProps = {
  categoryOpen: null,
  closeFilterCategory: function closeFilterCategory() {},
  countryCode: 'INT',
  displayMode: DISPLAY_MODE_MAP,
  displayResults: true,
  filters: {},
  filtersSelected: [],
  isOpen: false,
  lang: 'en',
  locale: 'en_int',
  nbResults: 0,
  openFilterCategory: function openFilterCategory() {},
  storeLocatorUrl: '#',
  styleContainer: {},
  styleFilters: {},
  toggleFilters: function toggleFilters() {},
  triggerCallback: function triggerCallback() {},
  updateFilters: function updateFilters() {}
};

exports.default = (0, _reactTranslate.withTranslator)()(FilterBlock);


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/FilterBlock/FilterBlock.js
// module id = 248
// module chunks = 0